import { render } from "./Psychotherapy.vue?vue&type=template&id=31d87a5c"
import script from "./Psychotherapy.vue?vue&type=script&lang=js"
export * from "./Psychotherapy.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__